const referralProcesses = {
    colsOrder: ['data', 'count', 'amount', 'date', 'status'],
    cols: {
        data: {
            content: 'Данные',
            width: 47,
            isAdminMain: true,
        },
        count: {
            content: 'Выполнено',
            width: 12,
        },
        amount: {
            content: 'Вознаграждение',
            width: 14,
        },
        date: {
            content: 'Период',
            width: 12,
        },
        status: {
            content: 'Статус',
            width: 15,
        },
    },
    adminIndex: 0,
    deletesCols: [],
    url: 'referralProcess',
    emptyInfo: {
        title: 'Участников пока нет',
        description: 'Они будут отображаться здесь',
    },
} as const;

export default referralProcesses;
